var map = {
	"./brand-fill.svg": "aecb",
	"./brand.svg": "9ee1",
	"./calendar-event-fill.svg": "c4cd",
	"./calendar-event-line.svg": "1f04",
	"./catalog-fill.svg": "317b",
	"./catalog.svg": "4798",
	"./categories-fill.svg": "944a3",
	"./categories.svg": "77e9",
	"./countries-fill.svg": "c73d",
	"./countries.svg": "1d5e",
	"./coupon-fill.svg": "b977",
	"./coupon.svg": "cd70",
	"./dashboard-fill.svg": "866a",
	"./dashboard.svg": "4ca1",
	"./delivery-boys-fill.svg": "b72d",
	"./delivery-boys.svg": "b359",
	"./delivery-fill.svg": "f7eb",
	"./delivery-requests-fill.svg": "e785",
	"./delivery-requests.svg": "5a47",
	"./delivery.svg": "fc31",
	"./emailSettings-fill.svg": "f6b8",
	"./emailSettings.svg": "b392",
	"./faq-fill.svg": "06c0",
	"./faq.svg": "2e0a",
	"./generalSettings.svg": "9b43",
	"./generalSettingsActive.svg": "e4c9",
	"./info-fill.svg": "91c6",
	"./info.svg": "8921",
	"./login-fill.svg": "5600",
	"./login.svg": "ef53",
	"./messages-fill.svg": "37a7",
	"./messages.svg": "85a8",
	"./notification-fill.svg": "4adf",
	"./notification.svg": "d854",
	"./orders-fill.svg": "870a",
	"./orders.svg": "be98",
	"./payment-fill.svg": "08eb",
	"./payment.svg": "2bac",
	"./platforms-fill.svg": "297f",
	"./platforms.svg": "ce93",
	"./product-fill.svg": "c969",
	"./product.svg": "de15",
	"./roles-fill.svg": "d670",
	"./roles.svg": "879b",
	"./settings-fill.svg": "f13b",
	"./settings.svg": "3ac1",
	"./slider-fill.svg": "bfad",
	"./slider.svg": "a9a5",
	"./star-fill.svg": "9c7a",
	"./star.svg": "94e3",
	"./store-fill.svg": "b15f",
	"./store.svg": "c501",
	"./terms-fill.svg": "cac6",
	"./terms.svg": "bd3e",
	"./users-fill.svg": "ffbb",
	"./users.svg": "ebae",
	"./vendor-active.svg": "b2d4",
	"./vendor.svg": "eda5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b7b5";